import React, { useState, useEffect, useContext } from "react";
import Axios from "axios";
import { API_URL } from "../components/api";
import Select from "react-select";
import AuthContext from "../context/AuthContext";

function AddIPTV(props) {
  const { user } = useContext(AuthContext);
  const authTokens = JSON.parse(localStorage.getItem("authTokens"));

  const [plans, setPlans] = useState([]);
  const [addons, setAddons] = useState([]);

  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [note, setNote] = useState("");
  const [name, setName] = useState("");
  const [pack, setPack] = useState(""); // iptv_plan_id
  const [selectedAddons, setSelectedAddons] = useState([]); // [{label,value}]
  const [submitting, setSubmitting] = useState(false);

  const refreshPage = () => window.location.reload(false);

  useEffect(() => {
    let mounted = true;

    const headers = {
      Authorization: `Bearer ${authTokens.access}`,
      "Content-Type": "application/json",
    };

    const loadPlans = async () => {
      try {
        const res = await Axios.get(`${API_URL}/radius/plans/iptv`, {
          headers,
          params: { username: "admin" },
        });
        if (mounted && res.status === 200) setPlans(res.data || []);
      } catch (e) {
        console.error(e);
      }
    };

    const loadAddons = async () => {
      try {
        const res = await Axios.get(`${API_URL}/radius/plans/iptv/addons`, {
          headers,
          params: { username: "admin" },
        });
        if (mounted && res.status === 200) setAddons(res.data || []);
      } catch (e) {
        console.error(e);
      }
    };

    loadPlans();
    loadAddons();
    return () => { mounted = false; };
  }, [API_URL]); // eslint-disable-line react-hooks/exhaustive-deps

  const planOptions = plans.map((p) => ({
    label: p.package_name,
    value: p.iptv_plan_id,
  }));

  const addonOptions = addons.map((a) => ({
    label: a.addon_name ?? a.name ?? a.package_name ?? `Addon ${a.iptv_addon_id}`,
    value: a.iptv_addon_id ?? a.addon_id ?? a.id,
  }));

  const validate = () =>
    code.trim() !== "" &&
    password.trim() !== "" &&
    note.trim() !== "" &&
    name.trim() !== "" &&
    pack !== "" &&
    selectedAddons.length >= 1;

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validate()) return;

  setSubmitting(true);
  try {
    await Axios.post(
      `${API_URL}/radius/subscriptions/iptv/`,
      {
        Action: "Post",
        code,
        password,
        name,
        notes: note,
        iptv_plan_id: pack,
        iptv_addon_ids: selectedAddons.map((x) => x.value), // ← all addons in one go
        userdealer: user.username,
      },
      { headers: { Authorization: `Bearer ${authTokens.access}` } }
    );

    refreshPage();
  } catch (err) {
    console.error(err);
  } finally {
    setSubmitting(false);
  }
};

  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <div className="name">
            <div className="form-group">
              <label>
                Name:
                <input
                  className="form-control"
                  type="text"
                  value={name}
                  required
                  placeholder="Name"
                  onChange={(e) => setName(e.target.value)}
                  disabled={submitting}
                />
              </label>
            </div>

            <div className="form-group">
              <label>
                Code:
                <input
                  className="form-control"
                  type="text"
                  value={code}
                  required
                  placeholder="Code"
                  onChange={(e) => setCode(e.target.value)}
                  disabled={submitting}
                />
              </label>
            </div>

            <div className="form-group">
              <label>
                Password:
                <input
                  className="form-control"
                  type="text"
                  value={password}
                  required
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={submitting}
                />
              </label>
            </div>
          </div>

          <label>
            Notes:
            <input
              className="form-control"
              type="text"
              value={note}
              required
              placeholder="Notes"
              onChange={(e) => setNote(e.target.value)}
              disabled={submitting}
            />
          </label>

          <label>
            Package:
            <Select
              className="search-line"
              placeholder="Choose Package"
              options={planOptions}
              onChange={(opt) => setPack(opt?.value || "")}
              isClearable
              isDisabled={submitting}
            />
          </label>

          <label>
            Addons (min 1):
            <Select
              className="search-line"
              placeholder="Choose Addons"
              options={addonOptions}
              value={selectedAddons}
              onChange={(opts) => setSelectedAddons(opts || [])}
              isMulti
              closeMenuOnSelect={false}
              isDisabled={submitting}
            />
          </label>

          <div className="fo">
            <button
              type="submit"
              className="btn btn-primary btn-md"
              disabled={!validate() || submitting}
            >
              {submitting ? "Creating…" : "Create"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddIPTV;
